import React from 'react';

const RequestFormHelp: React.FC = () => (
  <>
    <p>
      A request asks for something to be bought for work: a shelf, desk supplies, a tool.
      You say what you need; someone on the approver list says yes or no; someone on the
      buyer list buys it on a company card.
    </p>
    <p className="font-medium text-on-surface">Filling it in</p>
    <p>
      Say what it is for in a sentence, then list the items. A link and a rough price help
      the approver decide quickly. Press Enter in an item to move to the next one.
    </p>
    <p className="font-medium text-on-surface">Save draft or send</p>
    <p>
      Save draft keeps it for later; nobody else sees it. Send for approval tells the
      approvers in Slack and by email. You can still change it while it waits, but saving a
      change takes it back to draft, and you send it again.
    </p>
    <p className="font-medium text-on-surface">After that</p>
    <p>
      You hear when it is approved or denied, when it is bought, and when it arrives. A
      denied request comes back to you as a draft with the reason, so you can fix it and
      send it again, or cancel it.
    </p>
  </>
);

export default RequestFormHelp;
